import { CdkAccordion } from '@angular/cdk/accordion';
import { InjectionToken, QueryList } from '@angular/core';
import { AccordionItemComponent } from '@app/shared/components/accordion/accordion-item/accordion-item.component';

export interface AccordionBase extends CdkAccordion {
  itemComponents?: QueryList<AccordionItemComponent>;
}

export const APP_ACCORDION = new InjectionToken<AccordionBase>('APP_ACCORDION');
